import * as e from "react";
const r = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement("circle", { cx: 12.428, cy: 12, r: 12, fill: "#A1A1AC" }),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.929 11.77h-10.15M13.196 14.185l-2.417-2.417 2.417-2.416",
      stroke: "#fff",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.095 14.666v2.9a.926.926 0 01-.88.966H7.308a.925.925 0 01-.878-.966v-11.6A.925.925 0 017.307 5h7.909a.926.926 0 01.879.967v2.9",
      stroke: "#fff",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
), o = r;
export {
  o as default
};
